import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientname: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    StartTime: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    Notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Group Name:',
            mapping: 'clientname'
          },
         ]
        },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code:',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone:',
           mapping: 'telnumber'
         }
       ]
     },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:',
            mapping: 'email'
          },
         ]
        },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Event Date:',
              mapping: 'eventDate'
            }
          ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Event Type:',
              mapping: 'theme'
            }
          ]
        },
        {
          fields: [
            {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Event Start Time:',
              options: [
                { label: '7:30 AM', value: '07:30:00' },
                { label: '8:00 AM', value: '08:00:00' },
                { label: '8:30 AM', value: '08:30:00' },
                { label: '9:00 AM', value: '09:00:00' },
                { label: '9:30 AM', value: '09:30:00' },
                { label: '10:00 AM', value: '10:00:00' },
                { label: '10:30 AM', value: '10:30:00' },
                { label: '11:00 AM', value: '11:00:00' },
                { label: '11:30 AM', value: '11:30:00' },
                { label: '12:00 PM', value: '12:00:00' },
                { label: '12:30 PM', value: '12:30:00' },
                { label: '1:00 PM', value: '13:00:00' },
                { label: '1:30 PM', value: '13:30:00' },
                { label: '2:00 PM', value: '14:00:00' },
                { label: '2:30 PM', value: '14:30:00' },
                { label: '3:00 PM', value: '15:00:00' },
                { label: '3:30 PM', value: '15:30:00' },
                { label: '4:00 PM', value: '16:00:00' },
                { label: '4:30 PM', value: '16:30:00' },
                { label: '5:00 PM', value: '17:00:00' },
                { label: '5:30 PM', value: '17:30:00' },
                { label: '6:00 PM', value: '18:00:00' },
                { label: '6:30 PM', value: '18:30:00' },
                { label: '7:00 PM', value: '19:00:00' },
                { label: '7:30 PM', value: '19:30:00' },
                { label: '8:00 PM', value: '20:00:00' },
                { label: '8:30 PM', value: '20:30:00' },
                { label: '9:00 PM', value: '21:00:00' },
                { label: '9:30 PM', value: '21:30:00' },
                { label: '10:00 PM', value: '22:00:00' },
                { label: '10:30 PM', value: '22:30:00' },
                { label: '11:00 PM', value: '23:00:00' },
                { label: '11:30 PM', value: '23:30:00' },
              ],
              mapping: 'StartTime'
            }
          ]
        },
         {
           fields: [
             {
                type: 'text',
                size: 'Medium',
                label: 'Estimated # of People:',
                mapping: 'plannedguestcount'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'Medium',
                label: 'Any Additional Details About Your Event?:',
                mapping: 'Notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Radisson Hotel Cincinnati Riverfront Contact Form',
    formId: '783',
    clientKey: '41A7A6DD-9910-4DB6-844F-FC4083CD820E',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
